export default __webpack_public_path__ + "static/media/menu.88eb9b75.svg";